<template>
  <slot />
</template>

<script setup>
import defineTourItem from "#blokkli/helpers/composables/defineTourItem";
import { getCurrentInstance } from "#imports";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  text: { type: String, required: true },
  selector: { type: String, required: false }
});
const findElement = (el) => {
  if (el instanceof Text) {
    return findElement(el.nextElementSibling);
  } else if (el instanceof HTMLElement) {
    return el;
  }
};
const instance = getCurrentInstance();
defineTourItem(() => {
  return {
    id: props.id,
    title: props.title,
    text: props.text,
    element: () => {
      const provided = props.selector ? document.querySelector(props.selector) : void 0;
      const element = provided || findElement(instance?.vnode.el);
      if (element instanceof HTMLElement) {
        return element;
      }
    }
  };
});
</script>
